import { useCallback, useMemo } from 'react';
import { getFlags } from '../utils/flags.js';

/**
 * These hooks also exist in `@web/lib/memoization/hooks`. FPL owns this implementation because
 * `@figma/fpl-components` is built and published independently and cannot depend on private Web
 * packages.
 */
function useMemoIfFlagEnabled(getValue, dependencies, flagName) {
    const isEnabled = getFlags()[flagName] === true;
    if (!isEnabled)
        return getValue();
    // eslint-disable-next-line react-hooks/rules-of-hooks, react-hooks/exhaustive-deps -- flag assignments are sticky and callers control the dependencies
    return useMemo(getValue, dependencies);
}
function useCallbackIfFlagEnabled(callback, dependencies, flagName) {
    const isEnabled = getFlags()[flagName] === true;
    if (!isEnabled)
        return callback;
    // eslint-disable-next-line react-hooks/rules-of-hooks, react-hooks/exhaustive-deps -- flag assignments are sticky and callers control the dependencies
    return useCallback(callback, dependencies);
}

export { useCallbackIfFlagEnabled, useMemoIfFlagEnabled };
//# sourceMappingURL=use-memoization.js.map
